import React from "react";
import { Dots } from "react-activity";
import "react-activity/dist/library.css";

const ActivityIndicator = (props) => {
  return <Dots {...props}/>;
};

export default ActivityIndicator